<template>
  <div class="select" :class="{'is-loading': loading}" :cy-data="`select-container-${cyDataString}`" >
    <select @change="onChange" v-model="val" :cy-data="`select-${cyDataString}`">
      <option v-if="showEmpty" :value="null" disabled>- select an option -</option>
      <option
        v-for="(option, index) in optionsArray"
        :key="index"
        :value="typeof option === 'object' ? option : index"
      >
        <slot :option="option">{{ option }}</slot>
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'select-field-mod',
  props: {
    value: {
      // eslint-disable-next-line
      type: Object | String,
      default: null,
    },
    options: {
      type: Function,
    },
    showEmpty: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    cyData: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      val: this.value,
      optionsArray: [],
      loading: false,
    };
  },
  computed: {
    cyDataString() {
      const fieldLabel = this.cyData ? this.cyData : this.label;
      if (!fieldLabel) {
        return "";
      }
      return fieldLabel.replaceAll(/[ ']/g, "");
    },
  },
  mounted() {
    this.refresh();
  },
  watch: {
    value(val) {
      this.val = val;
    },
  },
  methods: {
    refresh() {
      this.loading = true;
      this.options((data) => {
        this.loading = false;
        this.optionsArray = data;
      });
    },
    onChange() {
      this.$emit('input', this.val);
    },
  },
};
</script>

<style lang='scss' scoped>
</style>
